import React, { useState } from 'react';
import SurveyForm2 from "../surveyform2/survey_form_2"; // import your survey form
import './Section_5.css';



function Section5({ sectionConfig }) {

  const [showSurvey, setShowSurvey] = useState(false);
  const handleCloseSurvey = () => {
      setShowSurvey(false);
    };


  if (!sectionConfig || !sectionConfig.stats) return null;

  return (
    <>
    <section className="section-5">
      <div className="section-5-card">
        <h1 className="section-5-title">{sectionConfig.title}</h1>

        <div className="stats-row">
          {sectionConfig.stats.map((stat, idx) => (
            <div key={idx} className="stat-section">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-subtitle">{stat.subtitle}</div>
              <div className="stat-description">{stat.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
    {/* Survey modal */}
      {showSurvey && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={handleCloseSurvey}>
              ✖
            </button>
            <SurveyForm2 />
          </div>
        </div>
      )}
    </>
  );
}

export default Section5;